const axios = require('axios');
const log = require('loglevel');
const ethers = require("ethers").ethers;
const BigNumber = ethers.BigNumber;
const moment = require('moment');

const isBOT = process.env.BOT === 1 ? true : false;

const maxUINT = ethers.constants.MaxUint256;
const ZERO18 = '000000000000000000';
const ZERO6 = '000000';

const CHAIN_ID = 1030;
const EURL = 'https://evm.confluxscan.io';

const TOKEN_JSON = require('./json/Token.json');
const TOKEN_ABI = TOKEN_JSON.abi;
const TOKEN_ADDRESS = TOKEN_JSON.networks[CHAIN_ID].address;

const ERC20_JSON = require('./json/ERC20.json');
const ERC20_ABI = ERC20_JSON.abi;

const USDT_ADDRESS = '0xfe97e85d13abd9c1c33384e796f10b73905637ce';
const LP_ADDRESS = '0x87a340a3aBb0c20ea047FF4C1A55b3356f850788';

const NFT_JSON = require('./json/NFTV9.json');
const NFT_ABI = NFT_JSON.abi;
const NFT_ADDRESS = NFT_JSON.networks[CHAIN_ID].address;

const TREASURY_JSON = require('./json/TreasuryV4.json');
const TREASURY_ABI = TREASURY_JSON.abi;
const TREASURY_ADDRESS = TREASURY_JSON.networks[CHAIN_ID].address;

const UNISWAPV2ROUTER02_ABI = require('./json2/uniswapv2router02abi.json');
const UNISWAPV2FACTORY_ABI = require('./json2/uniswapv2factoryabi.json');
const UNISWAPV2PAIR_ABI = require('./json2/IPAIR.json').abi;

const ROUTER_ADDRESS = '0x62b0873055bf896dd869e172119871ac24aea305';
const FACTORY_ADDRESS = '0xe2a6f7c0ce4d5d300f97aa7e125455f5cd3342f5';

const BUYER_JSON = require('./json3/BuyerV2.sol/BuyerV2.json');
const BUYER_ABI = BUYER_JSON.abi;
const BUYER_ADDRESS = '0x3Ce240536BC5fC9083F42a4E6d1Bb83cA63161b8';

const LPVAULT_JSON = require('./json3/LPVaultV2.sol/LPVaultV2.json');
const LPVAULT_ABI = LPVAULT_JSON.abi;
const LPVAULT_ADDRESS = '0xedd7F777E6eF1365195D97727b333C99E165863D';

const IPP_JSON = require('./json/PoSPool.json');
const IPP_ABI = IPP_JSON.abi;
const IPP_ADDRESS = '0x3cbc6F7D406fe9701573FE6DdF28f4F17b5d46A3';

const BCV_JSON = require('./json3/BCurveV1.sol/BCurveV1.json');
const BCV_ABI = BCV_JSON.abi;
const BCV_ADDRESS = '0x7B158d41e4f6fd503624D1A39824da9A6b36893A';

const VOTE1_JSON = require('./json3/Vote1V2.sol/Vote1V2.json');
const VOTE1_ABI = VOTE1_JSON.abi;
const VOTE1_ADDRESS = '0x41511304735E558210AD6851c5e26463081e548d';

let PROVIDER;
let TOKEN;
let USDT;
let LPTOKEN;
let SIGNER;
let NFT;
let TREASURY;
let ROUTER;
let FACTORY;
let BUYER;
let LPVAULT;
let IPP;
let BCV;
let VOTE1;

async function detectMetamask() {
  if (!window.ethereum) throw new Error('Please install Metamask and reload!');

  window.ethereum.on('chainChanged', (_chainId) => window.location.reload());

  let chainId = await window.ethereum.request({ method: 'eth_chainId' });
  chainId = Number(chainId);
  if (chainId !== CHAIN_ID) throw new Error('Please connect metamask to right network!');

  let connected = window.ethereum.isConnected();

  return connected;
}

async function loadMetamask() {
  window.ethereum.enable();
  PROVIDER = new ethers.providers.Web3Provider(window.ethereum);
  SIGNER = PROVIDER.getSigner();
  TOKEN = new ethers.Contract(TOKEN_ADDRESS, TOKEN_ABI, SIGNER);
  USDT = new ethers.Contract(USDT_ADDRESS, ERC20_ABI, SIGNER);
  NFT = new ethers.Contract(NFT_ADDRESS, NFT_ABI, SIGNER);
  TREASURY = new ethers.Contract(TREASURY_ADDRESS, TREASURY_ABI, SIGNER);
  ROUTER = new ethers.Contract(ROUTER_ADDRESS, UNISWAPV2ROUTER02_ABI, SIGNER);
  FACTORY = new ethers.Contract(FACTORY_ADDRESS, UNISWAPV2ROUTER02_ABI, SIGNER);
  BUYER = new ethers.Contract(BUYER_ADDRESS, BUYER_ABI, SIGNER);
  LPVAULT = new ethers.Contract(LPVAULT_ADDRESS, LPVAULT_ABI, SIGNER);
  LPTOKEN = new ethers.Contract(LP_ADDRESS, UNISWAPV2PAIR_ABI, SIGNER);
  IPP = new ethers.Contract(IPP_ADDRESS, IPP_ABI, SIGNER);
  BCV = new ethers.Contract(BCV_ADDRESS, BCV_ABI, SIGNER);
  VOTE1 = new ethers.Contract(VOTE1_ADDRESS, VOTE1_ABI, SIGNER);

  // bugfix: nft unstaked user cant stake again
  // const check = '0x88b280e521bf47f950dc50df35c10265e5f01534';
  // const ct = await LPVAULT.currentTurn();
  // log.debug('ct:', ct.toNumber());
  // const lpc1 = await LPVAULT.getUserData(check);
  // log.debug(lpc1[0].toNumber());
  // log.debug(lpc1[1].toNumber());
  // log.debug(lpc1[2].toNumber());
  // const lpc2 = await LPVAULT.getUnclaimedReward(check);
  // log.debug(lpc2);

  // const tv = await TREASURY.getContractVersion();
  // log.debug('treasury ver: ', tv);

  // const vr = await VOTE1.getVoteResult();
  // log.debug('vote 1 result: ', vr.toNumber());

  // const ui = await IPP.userInterest(NFT_ADDRESS);
  // const us = await IPP.userSummary(NFT_ADDRESS);

  // const wcfx = await IPP.withdrawableCfx();
  // log.debug('wcfx: ', wei2eth(wcfx));

  // const block = await PROVIDER.getBlock();
  // log.debug(block);

  // log.debug(IPP);
  // const uiqq = await IPP.userInQueue(NFT_ADDRESS, 0, 20);
  // log.debug('user in queue');
  // log.debug('uiqq.length: ', uiqq.length);
  // for (let i = 0; i < uiqq.length; i++) {
  //   const ui = uiqq[i];
  //   const endBlock = ui.endBlock.toNumber();
  //   const votePower = ui.votePower.toNumber();
  //   const curBlock = block.number;
  //   const delta = (endBlock - curBlock) * 1.2; // 1 block numer = 1.2 sec
  //   const hour = Math.ceil(delta / 3600);
  //   const days = Math.ceil(delta / (3600 * 24));
  //   log.debug({ endBlock, votePower, delta, hour, days });
  // }

  // log.debug('** us **');
  // log.debug(us);
  // log.debug('locked: ', us.locked.toString());
  // log.debug('unlocked: ', us.unlocked.toString());
  // log.debug('available: ', us.available.toString());
  // log.debug('votes: ', us.votes.toString());
  // log.debug(uiqq);
  // log.debug(NFT_ADDRESS);

  // const uoqq = await IPP.userOutQueue(NFT_ADDRESS);
  // log.debug('user out queue num:', uoqq.length);
  // for (let i = 0; i < uoqq.length; i++) {
  //   const uo = uoqq[i];
  //   log.debug(uo);
  //   const endBlock = uo.endBlock.toNumber();
  //   const votePower = uo.votePower.toNumber();
  //   const curBlock = block.number;
  //   const delta = (endBlock - curBlock) * 1.2; // 1 block numer = 1.2 sec
  //   const hour = Math.ceil(delta / 3600);
  //   const days = Math.ceil(delta / (3600 * 24));
  //   log.debug({ endBlock, votePower, delta, hour, days });
  // }

  log.debug('** smart contract initialized **');

  const userAddress = await SIGNER.getAddress();
  return userAddress;
}

async function loadPrivateKey(pk, providerUrl) {
  PROVIDER = new ethers.providers.JsonRpcProvider(providerUrl);
  SIGNER = new ethers.Wallet(pk, PROVIDER);
  TOKEN = new ethers.Contract(TOKEN_ADDRESS, TOKEN_ABI, SIGNER);
  USDT = new ethers.Contract(USDT_ADDRESS, ERC20_ABI, SIGNER);
  NFT = new ethers.Contract(NFT_ADDRESS, NFT_ABI, SIGNER);
  TREASURY = new ethers.Contract(TREASURY_ADDRESS, TREASURY_ABI, SIGNER);
  ROUTER = new ethers.Contract(ROUTER_ADDRESS, UNISWAPV2ROUTER02_ABI, SIGNER);
  FACTORY = new ethers.Contract(FACTORY_ADDRESS, UNISWAPV2ROUTER02_ABI, SIGNER);
  BUYER = new ethers.Contract(BUYER_ADDRESS, BUYER_ABI, SIGNER);
  LPVAULT = new ethers.Contract(LPVAULT_ADDRESS, LPVAULT_ABI, SIGNER);
  LPTOKEN = new ethers.Contract(LP_ADDRESS, UNISWAPV2PAIR_ABI, SIGNER);
  IPP = new ethers.Contract(IPP_ADDRESS, IPP_ABI, SIGNER);
  BCV = new ethers.Contract(BCV_ADDRESS, BCV_ABI, SIGNER);
  VOTE1 = new ethers.Contract(VOTE1_ADDRESS, VOTE1_ABI, SIGNER);

  log.debug('** smart contract initialized **');
}

async function loadWalletRandom() {
  const tmp = ethers.Wallet.createRandom();
  return await loadWallet(tmp.privateKey);
}

async function loadWallet(pk) {
  let provider = new ethers.providers.JsonRpcProvider(PROVIDER_URL);
  const wallet = new ethers.Wallet(pk, provider);
  return wallet;
}

function wei2eth(wei) {
  return ethers.utils.formatUnits(wei, "ether");
}

function eth2wei(eth) {
  return ethers.utils.parseEther(eth);
}

async function userData() {
  const userAddress = await SIGNER.getAddress();
  const totalSupply = await TOKEN.totalSupply();
  const userUSDT = await USDT.balanceOf(userAddress);
  const userToken = await TOKEN.balanceOf(userAddress);
  const userETH = await PROVIDER.getBalance(userAddress);
  const block = await PROVIDER.getBlock();
  const ts = block.timestamp;
  const buyerOwner = await BUYER.owner();
  const isAdmin = userAddress.toLowerCase() === buyerOwner.toLowerCase();

  const ret = {
    tokenTotalSupply: wei2eth(totalSupply),
    userAddress,
    userUSDT: wei2eth(userUSDT),
    userETH: wei2eth(userETH),
    userToken: wei2eth(userToken),
    blocktime: ts,
    isAdmin
  }

  log.debug('** userData **');
  log.debug(ret);
  return ret;
}

async function ethTransfer(to, amountWei) {
  let opt = {
    to: to,
    value: amountWei
  }
  let tx = await SIGNER.sendTransaction(opt);
  await tx.wait();
  log.debug('ethTransfer tx:' + tx.hash);
  return tx.hash;
}

async function tokenApprove(spender) {
  log.debug('tokenApprove..');
  const tx = await TOKEN.approve(spender, maxUINT);
  await tx.wait();
  return tx.hash;
}

async function tokenBurnAll() {
  log.debug('tokenBurnAll..');
  const userAddress = await SIGNER.getAddress();
  const balance = await TOKEN.balanceOf(userAddress);
  const tx = await TOKEN.burn(balance);
  await tx.wait();
  return tx.hash;
}

async function usdtApprove(spender) {
  log.debug('usdtApprove..');
  const tx = await USDT.approve(spender, maxUINT);
  await tx.wait();
  return tx.hash;
}

async function routerBuyUsdt(amountEth) {
  const amountWei = eth2wei(amountEth);
  const router = ROUTER;
  const addressWETH = await router.WETH();

  let path = [
    addressWETH,
    USDT_ADDRESS
  ];

  const amountOutMin = '1';
  const myAddress = await SIGNER.getAddress();
  const deadline = moment().unix() + 300;

  const options = { value: amountWei };
  const swapResult = await router.swapExactETHForTokens(amountOutMin, path, myAddress, deadline, options);

  log.debug('routerBuyUsdt tx: ' + swapResult.hash);
  await swapResult.wait();
  return swapResult.hash;
}

async function routerBuyToken(amountEth) {
  const amountWei = eth2wei(amountEth);
  const router = ROUTER;

  let path = [
    USDT_ADDRESS,
    TOKEN_ADDRESS
  ];

  const amountOutMin = '1';
  const myAddress = await SIGNER.getAddress();
  const deadline = moment().unix() + 300;

  const swapResult = await router.swapExactTokensForTokens(
    amountWei,
    amountOutMin, // minimum
    path,
    myAddress,
    deadline
  );

  log.debug('routerBuyToken tx: ' + swapResult.hash);
  await swapResult.wait();
  return swapResult.hash;
}

async function nftData() {
  let m0 = moment().unix();
  const pospoolDelay = (3600 * 24 * 3); // eSpace PHX have this glitch
  const block = await PROVIDER.getBlock();
  const ts = block.timestamp;

  const ADDRESS_POSPOOL = await NFT.ADDRESS_POSPOOL();
  const ADDRESS_REVRECEIVER = await NFT.ADDRESS_REVRECEIVER();
  const ADDRESS_TOKEN = await NFT.ADDRESS_TOKEN();
  const lastUpdateTime = await NFT.lastUpdateTime();
  const nextUpdateTimeStart = lastUpdateTime.toNumber() + (3600 * 24);
  const nextUpdateTime = lastUpdateTime.toNumber() + (3600 * 24);

  const ts1 = lastUpdateTime.toNumber() - 1800;
  const ts2 = lastUpdateTime.toNumber() + 1800;
  const ts3 = (lastUpdateTime.toNumber() + (3600 * 24)) - 1800;
  const ts4 = (lastUpdateTime.toNumber() + (3600 * 24)) + 1800;
  const freezeTime = (ts >= ts1 && ts <= ts2) || (ts >= ts3 && ts <= ts4);

  const session = await NFT.session();
  const rewardPerNFT = await NFT.rewardPerNFT();
  const stat = await NFT.stat();

  const dataListLength = stat[0].toNumber();
  const wrListLength = stat[1].toNumber();
  log.debug('nftData1 ', (moment().unix() - m0), ' secs');
  m0 = moment().unix()

  const dataList = [];
  for (let i = 1; i < dataListLength; i++) {
    const row = await NFT.dataListAtIndex(i);
    dataList.push({
      id: row[0].toNumber(),
      createdTime: row[1].toNumber(),
      allowBurnTime: row[2].toNumber() + pospoolDelay,
      session: row[3].toNumber()
    });
  }
  log.debug('nftData2 ', (moment().unix() - m0), ' secs');
  m0 = moment().unix()

  const userOwnedNFTIds = [];
  const userAddress = await SIGNER.getAddress();
  const num = await NFT.balanceOf(userAddress);
  for (let i = 0; i < num.toNumber(); i++) {
    const nftId = await NFT.tokenOfOwnerByIndex(userAddress, i);
    userOwnedNFTIds.push(nftId.toNumber());
  }

  log.debug('nftData3 ', (moment().unix() - m0), ' secs');
  m0 = moment().unix()


  const balanceToken = await TOKEN.balanceOf(NFT_ADDRESS);
  const balanceUSDT = await USDT.balanceOf(NFT_ADDRESS);
  const balanceETH = await PROVIDER.getBalance(NFT_ADDRESS);

  let revenue = 0;
  let mayUpdate = false;
  let mayWithdraw = false;
  let newSession;
  try {
    const ret = await NFT.callStatic.update();
    revenue = ret[0];
    newSession = ret[1].toNumber();
    mayUpdate = newSession > session.toNumber();
    log.debug('** nft update static success **');
    log.debug({ revenue, newSession });
  } catch (err) {
    log.debug('** nft update error **');
    log.error(err);
  }

  log.debug('nftData4 ', (moment().unix() - m0), ' secs');
  m0 = moment().unix()

  let pendingWithdraw = false;
  let pendingWithdrawIndex;
  let pendingWithdrawDeadline;

  log.debug('** withdraw list **');
  for (let i = 0; i < wrListLength; i++) {
    const row = await NFT.withdrawListAtIndex(i);
    log.debug(row);
    const claimer = row[0];
    const deadline = row[2].toNumber() + pospoolDelay;
    const done = row[3];
    if (claimer.toUpperCase() === userAddress.toUpperCase() && !done) {
      pendingWithdraw = true;
      pendingWithdrawIndex = i;
      pendingWithdrawDeadline = deadline;
      mayWithdraw = ts > deadline;
      break;
    }
  }

  log.debug('nftData5 ', (moment().unix() - m0), ' secs');
  m0 = moment().unix()

  const numNFT = await NFT.totalSupply();
  const ui = await IPP.userInterest(NFT_ADDRESS);

  log.debug('nftData6 ', (moment().unix() - m0), ' secs');
  m0 = moment().unix()

  const ret = {
    revenue: wei2eth(ui),
    totalNFT: numNFT.toNumber(),
    ADDRESS_POSPOOL,
    ADDRESS_REVRECEIVER,
    ADDRESS_TOKEN,
    lastUpdateTime: lastUpdateTime.toNumber(),
    nextUpdateTime,
    session: session.toNumber(),
    newSession,
    rewardPerNFT: wei2eth(rewardPerNFT),
    dataList,
    userOwnedNFTIds,
    balanceToken: wei2eth(balanceToken),
    balanceETH: wei2eth(balanceETH),
    balanceUSDT: wei2eth(balanceUSDT),
    revenue: wei2eth(revenue),
    mayUpdate,
    mayWithdraw,
    pendingWithdraw,
    pendingWithdrawIndex,
    pendingWithdrawDeadline,
    freezeTime
  }

  log.debug('** nftData **');
  log.debug(ret);

  // await checkPool();
  return ret;
}

async function nftMint() {
  const receiver = await SIGNER.getAddress();
  const options = { value: eth2wei('1000') };
  const tx = await NFT.mint(receiver, options);

  log.debug('nftMint tx: ' + tx.hash);
  await tx.wait();
  return tx.hash;
}

async function nftBurn(nftId) {
  const tx = await NFT.burn(nftId);
  log.debug('nftBurn tx: ' + tx.hash);
  await tx.wait();
  return tx.hash;
}

async function nftClaim(nftId) {
  const tx = await NFT.claim(nftId);
  log.debug('nftClaim tx: ' + tx.hash);
  await tx.wait();
  return tx.hash;
}

async function nftWithdraw(index) {
  log.debug('nftWithdraw for index: ', index);
  const tx = await NFT.withdraw(index);
  log.debug('nftWithdraw tx: ' + tx.hash);
  await tx.wait();
  return tx.hash;
}

async function nftUpdate() {
  const tx = await NFT.update();
  log.debug('nftUpdate tx: ' + tx.hash);
  await tx.wait();
  return tx.hash;
}

async function nftSendRevenue() {
  const tx = await NFT.sendRevenue();
  log.debug('nftSendRevenue tx: ' + tx.hash);
  await tx.wait();
  return tx.hash;
}

async function coinToToken(amount) {
  const userAddress = await SIGNER.getAddress();
  const result = await TREASURY.coinToToken(eth2wei(amount), userAddress);
  return wei2eth(result);
}

async function coinToTokenFromDex(amount) {
  const result = await swapUSDT2Token(amount)
  return wei2eth(result);
}

async function tokenToCoin(amount) {
  const userAddress = await SIGNER.getAddress();
  const result = await TREASURY.tokenToCoin(eth2wei(amount), userAddress);
  return wei2eth(result);
}

async function treasuryData() {

  const ADDRESS_COIN = await TREASURY.ADDRESS_COIN();
  const ADDRESS_TOKEN = await TREASURY.ADDRESS_TOKEN();
  const ADDRESS_NFT = await TREASURY.ADDRESS_NFT();
  const START_PRICE = await TREASURY.START_PRICE();
  const lastUpdateTime = await TREASURY.lastUpdateTime();
  const basePrice = await TREASURY.getBasePrice();

  const userAddress = await SIGNER.getAddress();
  const otherAddress = TREASURY_ADDRESS;
  const ownerAddress = await TREASURY.owner();

  const b = await TREASURY.coinToToken(eth2wei('1'), userAddress);
  const a = BigNumber.from(eth2wei('1'));
  let buyPrice = a.mul(eth2wei('1')).div(b);
  let sellPrice = await TREASURY.tokenToCoin(eth2wei('1'), userAddress);
  const price = await TREASURY.tokenToCoin(eth2wei('1'), userAddress);
  const balanceToken = await TOKEN.balanceOf(TREASURY_ADDRESS);
  const balanceUSDT = await USDT.balanceOf(TREASURY_ADDRESS);
  const balanceETH = await PROVIDER.getBalance(TREASURY_ADDRESS);

  const userUSDTAllowance = await USDT.allowance(userAddress, TREASURY_ADDRESS);
  const userTokenAllowance = await TOKEN.allowance(userAddress, TREASURY_ADDRESS);
  const userUSDT = await USDT.balanceOf(userAddress);
  const userToken = await TOKEN.balanceOf(userAddress);
  const userUSDTAllowanceOK = userUSDTAllowance.gte(userUSDT);
  const userTokenAllowanceOK = userTokenAllowance.gte(userToken);

  const block = await PROVIDER.getBlock();
  const ts = block.timestamp;

  const mayUpdate = balanceUSDT.gte(1 + ZERO18) && (ts > lastUpdateTime.toNumber());

  let swapBuyPrice = '0';
  let swapSellPrice = '0';

  try {
    const a = await swapToken2USDT('1');
    swapSellPrice = wei2eth(a);
  } catch (err) {
    log.error(err);
  }

  try {
    const amountUSDT = '0.01';
    const b = await swapUSDT2Token(amountUSDT);
    const a = BigNumber.from(eth2wei(amountUSDT) + ZERO18);
    const c = a.div(b);
    swapBuyPrice = wei2eth(c);
  } catch (err) {
    log.error(err);
  }

  buyPrice = wei2eth(buyPrice);
  sellPrice = wei2eth(sellPrice);
  let enableArbitrage = false;

  let doArbitrage = false;
  if (Number(swapBuyPrice) < Number(sellPrice)) {
    enableArbitrage = true;
  }

  if (Number(buyPrice) < Number(swapSellPrice)) {
    enableArbitrage = true;
  }

  log.debug('** arbitrage ** ', enableArbitrage);

  // bcv here
  const bp = await TREASURY.getBasePrice();
  const pdArr = await BCV.getPriceData();

  log.debug('** bcv data **');
  log.debug({
    bp1: bp.toString(),
    bp2: pdArr[0].toString(),
    cp2: pdArr[1].toString(),
    mp2: pdArr[2].toString()
  });

  let bonus = 0;
  let bonusSample = 10000;

  const tokenFromSwap = await swapUSDT2Token('' + bonusSample);
  const tokenFromCult = await TREASURY.coinToToken(eth2wei('' + bonusSample), userAddress);
  log.debug('** bonus calc **');
  log.debug('swap:', wei2eth(tokenFromSwap));
  log.debug('cult:', wei2eth(tokenFromCult));
  if (tokenFromCult.gt(tokenFromSwap)) {
    const a = tokenFromCult.sub(tokenFromSwap);
    const b = a.mul(100).div(tokenFromSwap);
    bonus = b.toNumber();
  }

  log.debug('bonus percentage ', bonus);



  const ret = {
    ADDRESS: TREASURY_ADDRESS,
    ADDRESS_COIN,
    ADDRESS_TOKEN,
    ADDRESS_NFT,
    START_PRICE: START_PRICE.toString(),
    buyPrice: buyPrice,
    sellPrice: sellPrice,
    swapBuyPrice,
    swapSellPrice,
    enableArbitrage,
    price: wei2eth(price),
    lastUpdateTime: lastUpdateTime.toNumber(),
    basePrice: wei2eth(basePrice),
    balanceToken: wei2eth(balanceToken),
    balanceETH: wei2eth(balanceETH),
    balanceUSDT: wei2eth(balanceUSDT),
    userUSDTAllowance: userUSDTAllowance.toString(),
    userTokenAllowance: userTokenAllowance.toString(),
    userUSDTAllowanceOK,
    userTokenAllowanceOK,
    mayUpdate,
    bonus,
    bonusSample
  }

  log.debug(ret);
  return ret;
}

async function swapCoinToToken(amount, nftId) {
  if (!nftId) nftId = 1;
  const userAddress = await SIGNER.getAddress();
  const tx = await TREASURY.swapCoinToToken(
    eth2wei(amount),
    userAddress,
    nftId
  );
  log.debug('swapCoinToToken tx: ' + tx.hash);
  await tx.wait();
  return tx.hash;
}

async function swapTokenToCoin(amount, nftId) {
  log.debug('amount: ', amount);
  if (!nftId) nftId = 0;
  const userAddress = await SIGNER.getAddress();
  const tx = await TREASURY.swapTokenToCoin(
    eth2wei(amount),
    userAddress,
    nftId
  );
  log.debug('swapTokenToCoin tx: ' + tx.hash);
  await tx.wait();
  return tx.hash;
}

async function treasuryUpdate() {
  const tx = await TREASURY.update();
  log.debug('treasuryUpdate tx: ' + tx.hash);
  await tx.wait();
  return tx.hash;
}

async function buyerData() {

  const balanceETH = await PROVIDER.getBalance(BUYER_ADDRESS);
  const balanceUSDT = await USDT.balanceOf(BUYER_ADDRESS);
  const ADDRESS_ROUTER = await BUYER.ADDRESS_ROUTER();
  let ethRevenue = 0;
  let tokenBurn = 0;
  let mayBuy = false;
  try {
    const ret = await BUYER.callStatic.buyAndBurn(1, 1);
    ethRevenue = wei2eth(ret[0]);
    tokenBurn = wei2eth(ret[1]);
    log.debug({ ret });
    mayBuy = Number(ethRevenue) > 0;
  } catch (err) {
    log.debug('** buy & burn fail **');
    // log.error(err);
  }

  let mayUpdate = false;
  try {
    log.debug('BUYER.callStatic.update()');
    await BUYER.callStatic.update();
    mayUpdate = true;
  } catch (err) {
    log.debug('** buyer update fail **');
    // if (err && err.reason) log.error(err.reason);
    // else log.error(err);
  }

  const userAddress = await SIGNER.getAddress();
  const userUSDTAllowance = await USDT.allowance(userAddress, BUYER_ADDRESS);

  const session = await NFT.session();

  let nftRevenue = 0;
  let nftMayUpdate = false;
  try {
    const ret = await NFT.callStatic.update();
    nftRevenue = wei2eth(ret[0]);
    nftRevenue = Number(nftRevenue);
    const newSession = ret[1].toNumber();
    nftMayUpdate = newSession > session.toNumber();
  } catch (err) {
    log.debug('error nftRevenue && nftMayUpdate');
  }

  const ret = {
    address: BUYER_ADDRESS,
    balanceETH: wei2eth(balanceETH),
    balanceUSDT: wei2eth(balanceUSDT),
    ADDRESS_ROUTER,
    ethRevenue,
    tokenBurn,
    mayBuy,
    mayUpdate,
    userUSDTAllowance: userUSDTAllowance.toString(),
    nftRevenue,
    nftMayUpdate
  }

  log.debug('** buyerData **');
  log.debug(ret);
  return ret;
}

async function buyerBuy() {
  const tx = await BUYER.buyAndBurn(1, 1);
  log.debug('buyerBuy tx: ' + tx.hash);
  await tx.wait();
  return tx.hash;
}

async function buyerUpdate() {
  const tx = await BUYER.update();
  log.debug('BUYER.update() tx: ' + tx.hash);
  await tx.wait();
  return tx.hash;
}

async function swapToken2USDT(eth) {
  let amountIn = ethers.utils.parseEther(eth);
  let path = [
    TOKEN_ADDRESS,
    USDT_ADDRESS
  ];

  let result = await ROUTER.getAmountsOut(amountIn, path);
  return result[1];
}

async function swapUSDT2Token(eth) {
  let amountIn = ethers.utils.parseEther(eth);
  let path = [
    USDT_ADDRESS,
    TOKEN_ADDRESS
  ];

  let result = await ROUTER.getAmountsOut(amountIn, path);
  return result[1];
}

async function getPriceInfo(buyerAddress) {
  const b = await TREASURY.coinToToken(eth2wei('1'), buyerAddress);
  const a = BigNumber.from(eth2wei('1'));
  const buyPriceBN = a.mul(eth2wei('1')).div(b);
  const sellPriceBN = await TREASURY.tokenToCoin(eth2wei('1'), buyerAddress);
  const buyPrice = Number(wei2eth(buyPriceBN));
  const sellPrice = Number(wei2eth(sellPriceBN));

  let swapBuyPrice = '0';
  let swapSellPrice = '0';

  try {
    const a = await swapToken2USDT('1');
    swapSellPrice = Number(wei2eth(a));
  } catch (err) {
    log.debug('swapSellPrice error..');
    log.error(err);
  }

  try {
    const test = '0.01';
    const b = await swapUSDT2Token(test);
    const a = BigNumber.from(eth2wei(test) + ZERO18);
    const c = a.div(b);
    swapBuyPrice = Number(wei2eth(c));
  } catch (err) {
    log.debug('swapBuyPrice error..');
    log.error(err);
  }

  let doArbitrage = false;
  let strategy = 'stay out';

  if (swapBuyPrice < sellPrice) {
    doArbitrage = true;
    strategy = 'pump';
  }

  if (buyPrice < swapSellPrice) {
    doArbitrage = true;
    strategy = 'dump';
  }


  return { doArbitrage, strategy, swapBuyPrice, swapSellPrice, buyPrice, sellPrice };
}

async function runArbitrage(execute, nftId) {
  log.debug('** arbitrage **');

  const buyerAddress = BUYER_ADDRESS;
  const userAddress = await SIGNER.getAddress();
  let userUSDT = await USDT.balanceOf(userAddress);

  const mT = eth2wei('100');
  if (userUSDT.gte(mT)) userUSDT = mT;

  const b = await TREASURY.coinToToken(eth2wei('1'), buyerAddress);
  const a = BigNumber.from(eth2wei('1'));
  const buyPriceBN = a.mul(eth2wei('1')).div(b);
  const sellPriceBN = await TREASURY.tokenToCoin(eth2wei('1'), buyerAddress);
  const buyPrice = Number(wei2eth(buyPriceBN));
  const sellPrice = Number(wei2eth(sellPriceBN));

  let swapBuyPrice = '0';
  let swapSellPrice = '0';

  try {
    const a = await swapToken2USDT('1');
    swapSellPrice = Number(wei2eth(a));
  } catch (err) {
    log.debug('swapSellPrice error..');
    log.error(err);
  }

  try {
    const test = '1';
    const b = await swapUSDT2Token(test);
    const a = BigNumber.from(eth2wei(test) + ZERO18);
    const c = a.div(b);
    swapBuyPrice = Number(wei2eth(c));
  } catch (err) {
    log.debug('swapBuyPrice error..');
    log.error(err);
  }

  let doArbitrage = false;
  let strategy = 'stay out';

  if (swapBuyPrice < sellPrice) {
    doArbitrage = true;
    strategy = 'pump';
  }

  if (buyPrice < swapSellPrice) {
    doArbitrage = true;
    strategy = 'dump';
  }

  log.debug({ doArbitrage, swapBuyPrice, swapSellPrice, buyPrice, sellPrice });

  let bestCheck = { strategy: 'stay out', profit: '0' };
  let bestStart = 1;
  let best = { strategy: 'stay out', profit: '0' };

  if (doArbitrage) {
    const maxTest = wei2eth(userUSDT);

    // check for best start
    log.debug('** check for best start **');
    if (execute && strategy === 'dump') {
      const multiplier = 10;
      for (let ii = 1; ii < 10000; ii++) {
        const amountUSDT = ii * multiplier; // 10$
        if (amountUSDT > Number(maxTest)) break;
        const test = amountUSDT + '';

        const startBalance = eth2wei(test);
        const numToken = await TREASURY.coinToToken(startBalance, buyerAddress);
        const endBalance = await swapToken2USDT(wei2eth(numToken));
        if (endBalance.gt(startBalance)) {
          const profit = endBalance.sub(startBalance);
          const obj = { strategy, test, profit: wei2eth(profit) };
          log.debug(obj);

          if (Number(obj.profit) > Number(bestCheck.profit)) {
            bestCheck = obj;
          } else break;
        } else {
          log.debug('minus');
          log.debug({ startBalance: startBalance.toString(), endBalance: endBalance.toString() });
          break;
        }
      }

      bestStart = Number(bestCheck.test) - multiplier;
      if (bestStart > 0) {
        // sanity check
      } else {
        bestStart = 1;
      }

      log.debug('bestStart is ', bestStart);
    } else if (execute && strategy === 'pump') {
      const multiplier = 10;
      for (let ii = 1; ii < 10000; ii++) {
        const amountUSDT = ii * multiplier; // 10$
        if (amountUSDT > Number(maxTest)) break;
        const test = amountUSDT + '';
        const startBalance = eth2wei(test);
        const numToken = await swapUSDT2Token(test);
        const endBalance = await TREASURY.tokenToCoin(numToken, buyerAddress);
        if (endBalance.gt(startBalance)) {
          const profit = endBalance.sub(startBalance);
          const obj = { strategy, test, profit: wei2eth(profit) };
          log.debug(obj);

          if (Number(obj.profit) > Number(bestCheck.profit)) {
            bestCheck = obj;
          } else break;
        } else {
          log.debug('minus');
          log.debug({ startBalance: startBalance.toString(), endBalance: endBalance.toString() });
          break;
        }
      }

      bestStart = Number(bestCheck.test) - multiplier;
      if (bestStart > 0) {
        // sanity check
      } else {
        bestStart = 1;
      }

      log.debug('bestStart is ', bestStart);
    }


    log.debug('** done **');

    for (let i = bestStart; i < 10000; i++) {
      const amountUSDT = i; // 1$
      if (amountUSDT > Number(maxTest)) break;
      const test = amountUSDT + '';

      if (strategy === 'pump') {
        const startBalance = eth2wei(test);
        const numToken = await swapUSDT2Token(test);
        const endBalance = await TREASURY.tokenToCoin(numToken, buyerAddress);
        if (endBalance.gt(startBalance)) {
          const profit = endBalance.sub(startBalance);
          const obj = { strategy, test, profit: wei2eth(profit) };
          log.debug(obj);

          if (Number(obj.profit) > Number(best.profit)) {
            best = obj;
            if (!execute) break;
          } else break;
        } else {
          log.debug('minus');
          log.debug({ startBalance: startBalance.toString(), endBalance: endBalance.toString() });
          break;
        }
      } else if (strategy === 'dump') {
        const startBalance = eth2wei(test);
        const numToken = await TREASURY.coinToToken(startBalance, buyerAddress);
        const endBalance = await swapToken2USDT(wei2eth(numToken));
        if (endBalance.gt(startBalance)) {
          const profit = endBalance.sub(startBalance);
          const obj = { strategy, test, profit: wei2eth(profit) };
          log.debug(obj);

          if (Number(obj.profit) > Number(best.profit)) {
            best = obj;
            if (!execute) break;
          } else break;
        } else {
          log.debug('minus');
          log.debug({ startBalance: startBalance.toString(), endBalance: endBalance.toString() });
          break;
        }
      } else {
        break;
      }

    }

    try {
      if (execute) {
        log.debug('** execute **');
        log.debug(best);
        let tx;
        if (best.strategy === 'pump') {

          const maxTest = Number(best.test);
          const minTest = 1;
          for (let ii = maxTest; ii >= minTest; ii--) {
            try {
              const amount = eth2wei(ii + '');
              tx = await BUYER.buySwapSellTreasury(amount, nftId);
              log.debug('success tx for ', ii);
              break;
            } catch (err) {
              log.debug('error tx - test smaller from ', ii);
            }
          }

          await tx.wait();
          return tx.hash;
        } else if (best.strategy === 'dump') {

          const maxTest = Number(best.test);
          const minTest = 1;
          for (let ii = maxTest; ii >= minTest; ii--) {
            try {
              const amount = eth2wei(ii + '');
              tx = await BUYER.buyTreasurySellSwap(amount, nftId);
              log.debug('success tx for ', ii);
              break;
            } catch (err) {
              log.debug('error tx - test smaller from ', ii);
            }
          }

          await tx.wait();
          return tx.hash;
        } else {
          return false;
        }
      }
    } catch (err) {
      log.error(err);
    }

  }

  return best;
}

async function lpvaultData() {
  let m0 = moment().unix();

  const block = await PROVIDER.getBlock();
  const ts = block.timestamp;

  const ADDRESS_WALLET = await LPVAULT.ADDRESS_WALLET();
  const ADDRESS_TOKEN = await LPVAULT.ADDRESS_TOKEN();
  const ADDRESS_LPTOKEN = await LPVAULT.ADDRESS_LPTOKEN();

  const userAddress = await SIGNER.getAddress();
  const balanceLPTokenUser = await LPTOKEN.balanceOf(userAddress);
  const balanceLPTokenLPVault = await LPTOKEN.balanceOf(LPVAULT_ADDRESS);
  const balanceRewardLPWallet = await TOKEN.balanceOf(ADDRESS_WALLET);
  const balanceRewardLPVault = await TOKEN.balanceOf(LPVAULT_ADDRESS);

  const allowance = await LPTOKEN.allowance(userAddress, LPVAULT_ADDRESS);
  const approved = allowance.gte(balanceLPTokenUser.toString());

  const vaultTurn = (await LPVAULT.currentTurn()).toNumber();
  const arr = await LPVAULT.getUserData(userAddress);
  const userTurn = arr[0].toNumber();
  const userStake = arr[1];
  const userAllowUnstakeTime = arr[2].toNumber();
  const userUnclaimedReward = await LPVAULT.getUnclaimedReward(userAddress);

  log.debug('lpvaultData1: ', (moment().unix() - m0), ' secs');
  m0 = moment().unix();

  log.debug('** calc daily reward **');
  let dailyInterest = BigNumber.from('0');

  const rewardHistoryLength = (await LPVAULT.numRewardHistory()).toNumber();
  const rewardHistory = [];
  if (rewardHistoryLength > 2) {
    const minTime = ts - (3600 * 24 * 8); // 1 week

    let totRPS = BigNumber.from('0');
    let minTS = false;
    let maxTS = false;
    let i0 = rewardHistoryLength - 10;
    if (i0 < 0) i0 = 0;
    for (let i = i0; i < rewardHistoryLength; i++) {
      const arr = await LPVAULT.getRewardHistory(i);
      const reward = wei2eth(arr[0]);
      const totLP = wei2eth(arr[1]);
      const rps = arr[2];
      const ts = arr[3].toNumber();
      if (ts >= minTime) {
        const row = { reward, totLP, rps: wei2eth(rps), ts, datetime: moment.unix(ts).format('DD MMM HH:mm') }
        rewardHistory.unshift(row);
        log.debug(row);
        if (!minTS) {
          minTS = ts;
        } else {
          maxTS = ts;
          totRPS = totRPS.add(rps);
        }
      }
    }

    const delta = maxTS - minTS;
    const oneDay = 3600 * 24;
    dailyInterest = totRPS.mul(oneDay).div(delta);

    // const index2 = rewardHistoryLength - 1;
    // const index1 = index2 - 1;
    // const arr2 = await LPVAULT.getRewardHistory(index2);
    // const arr1 = await LPVAULT.getRewardHistory(index1);
    // // (reward, totalStake, rewardPerStake, createdAt);
    // const rewardPerStake = arr2[2];
    // const ts2 = arr2[3].toNumber();
    // const ts1 = arr1[3].toNumber();
    // const delta = ts2 - ts1;
    // const oneDay = 3600 * 24;
    // dailyInterest = rewardPerStake.mul(oneDay).div(delta);
  }

  log.debug('lpvaultData2: ', (moment().unix() - m0), ' secs');
  m0 = moment().unix();

  log.debug('** calc APY **');
  const totalSupplyLP = await LPTOKEN.totalSupply();
  const reserves = await LPTOKEN.getReserves();
  const reserve0 = reserves[0];
  const reserve1 = reserves[1];

  const singleLP = ethers.utils.parseEther('2');
  const oneLP2XYZ = singleLP.mul(reserve0).div(totalSupplyLP); // price of 1 LP in XYZ
  const oneLP2USDT = singleLP.mul(reserve1).div(totalSupplyLP); // price of 1 LP in XYZ

  const valueStaked = Math.floor(wei2eth(balanceLPTokenLPVault) * wei2eth(oneLP2USDT));

  const interest = Number(wei2eth(dailyInterest)) / Number(wei2eth(oneLP2XYZ));
  const interestPctgDaily = interest * 100;
  const interestPlusBase = 1 + interest;
  const apyCalc1 = Math.pow(interestPlusBase, 365);
  const apyCalc2 = apyCalc1 - 1;
  const apy = apyCalc2 * 100;
  const apr = interest * 365 * 100;

  const mayStake = balanceLPTokenUser.gt('0') && userUnclaimedReward.eq('0') && approved;
  const mayUnstake = userStake.gt('0') && userUnclaimedReward.eq('0') && (ts > userAllowUnstakeTime);
  const mayClaim = userUnclaimedReward.gt('0');

  const wdArr = await LPVAULT.getUserWithdrawData(userAddress);

  const userPendingWithdraw = wei2eth(wdArr[0]);
  const userAllowWithdrawTime = (wdArr[1]).toNumber();
  const mayWithdraw = Number(userPendingWithdraw) > 0 && (userAllowWithdrawTime < ts);

  const userStakedInUSDT = Math.floor(wei2eth(userStake) * wei2eth(oneLP2USDT));
  const userDailyInterestInToken = Number(wei2eth(dailyInterest)) * Number(wei2eth(userStake));

  const userDailyInterestInUSDT = userDailyInterestInToken ? wei2eth(await swapToken2USDT(userDailyInterestInToken + '')) : 0;
  const userYearlyInterestInUSDT = 365 * Number(userDailyInterestInUSDT);
  log.debug('lpvaultData3: ', (moment().unix() - m0), ' secs');
  m0 = moment().unix();

  const ret = {
    ADDRESS_WALLET,
    ADDRESS_TOKEN,
    ADDRESS_LPTOKEN,
    balanceLPTokenUser: wei2eth(balanceLPTokenUser),
    balanceLPTokenLPVault: wei2eth(balanceLPTokenLPVault),
    balanceRewardLPWallet: wei2eth(balanceRewardLPWallet),
    balanceRewardLPVault: wei2eth(balanceRewardLPVault),
    vaultTurn,
    userTurn,
    userStake: wei2eth(userStake),
    userStakedInUSDT,
    userDailyInterestInToken,
    userDailyInterestInUSDT,
    userYearlyInterestInUSDT,
    userAllowUnstakeTime,
    userUnclaimedReward: wei2eth(userUnclaimedReward),
    reserve0: reserve0.toString(),
    reserve1: reserve1.toString(),
    oneLP2XYZ: wei2eth(oneLP2XYZ),
    apy,
    apr,
    dailyInterest: wei2eth(dailyInterest),
    mayStake,
    mayUnstake,
    mayClaim,
    allowance,
    approved,
    ts,
    userPendingWithdraw,
    userAllowWithdrawTime,
    mayWithdraw,
    rewardHistory,
    valueStaked,
    interestPctgDaily
  }

  log.debug('** lpvaultData **')
  log.debug(ret);
  return ret;
}

async function lpvaultUpdate() {
  log.debug('lpvaultUpdate..');
  const tx = await LPVAULT.update();
  log.debug('tx: ' + tx.hash);
  await tx.wait();
  return tx.hash;
}

async function lpvaultApprove() {
  log.debug('lpvaultApprove..');
  const tx = await LPTOKEN.approve(LPVAULT_ADDRESS, maxUINT);
  log.debug('tx: ' + tx.hash);
  await tx.wait();
  return tx.hash;
}

async function lpvaultStake(amountETH) {
  log.debug('lpvaultStake..');
  const amount = eth2wei(amountETH);
  const tx = await LPVAULT.stakeLPToken(amount);
  log.debug('tx: ' + tx.hash);
  await tx.wait();
  return tx.hash;
}

async function lpvaultUnstake(amountETH) {
  log.debug('lpvaultUnstake..');
  const amount = eth2wei(amountETH);
  const tx = await LPVAULT.unstakeLPToken(amount);
  log.debug('tx: ' + tx.hash);
  await tx.wait();
  return tx.hash;
}

async function lpvaultClaim() {
  log.debug('lpvaultClaim..');
  const tx = await LPVAULT.claimReward();
  log.debug('tx: ' + tx.hash);
  await tx.wait();
  return tx.hash;
}

async function lpvaultWithdraw() {
  log.debug('lpvaultWithdraw..');
  const tx = await LPVAULT.withdrawLPToken();
  log.debug('tx: ' + tx.hash);
  await tx.wait();
  return tx.hash;
}

async function lpvaultTest1() {
  const amountWei = eth2wei('50000');
  const to = '0x3EfA8dA6001Fa333b37912b4C375Fc37073AA51f';
  const tx = await TOKEN.transfer(to, amountWei);
  log.debug('tx: ' + tx.hash);
  await tx.wait();
  return tx.hash;
}

async function checkPool() {
  const posAddr = await IPP._poolLockPeriod();
  log.debug({ posAddr });
}

async function bcvSetPricingScale(pctg) {
  log.debug('bcvSetPricingScale..');
  const tx = await BCV.setPricingScale(pctg);
  log.debug('tx: ' + tx.hash);
  await tx.wait();
  return tx.hash;
}

async function getSignature(msg) {
  log.debug('getSignature..');
  const sig = await SIGNER.signMessage(msg);
  log.debug('sig: ' + sig);
  return sig;
}

async function voteData(userNFTId) {
  const block = await PROVIDER.getBlock();
  const ts = block.timestamp;

  const stat = await VOTE1.stat();
  // participants.length, NUM_CHOICE, bestChoice, getVoteResult()
  const numParticipants = stat[0].toNumber();
  const numChoice = stat[1].toNumber();
  const bestChoice = stat[2].toNumber();
  const pctg = stat[3].toNumber();
  const multiplier = pctg / 20;

  const choices = [];
  for (let i = 1; i <= numChoice; i++) {
    const numVotes = await VOTE1.choiceStat(i);
    choices.push({ choiceId: i, numVotes: numVotes.toNumber(), voters: [] });
  }

  let nextVoteTime = 0;
  for (let i = 0; i < numParticipants; i++) {
    const nftId = await VOTE1.getParticipantAtIndex(i);
    const nftStat = await VOTE1.nftStat(nftId);
    // nftId2choice[nftId], nftId2nextVote[nftId]
    const index = nftStat[0].toNumber() - 1;
    choices[index].voters.push(nftId.toNumber());
    if (nftId.toString() === userNFTId + '') {
      nextVoteTime = nftStat[1].toNumber();
    }
  }

  const mayVote = userNFTId > 0 && nextVoteTime < ts;

  const ret = {
    numParticipants,
    bestChoice,
    pctg,
    multiplier,
    choices,
    nextVoteTime,
    mayVote
  }

  log.debug('** voteData **');
  log.debug(ret);
  return ret;
}

async function voteChoice(choiceId, nftId) {
  log.debug('voteChoice..');
  const tx = await VOTE1.vote(choiceId, nftId);
  log.debug('tx: ' + tx.hash);
  await tx.wait();
  return tx.hash;
}

async function adminData() {
  const priceArb = await getPriceInfo(BUYER_ADDRESS);
  const userAddress = await SIGNER.getAddress();
  const priceUser = await getPriceInfo(userAddress);
  log.debug({ priceArb, priceUser });
}


export default {
// module.exports = {
  EURL,
  ZERO18,
  ZERO6,
  CHAIN_ID,
  ROUTER_ADDRESS,
  TREASURY_ADDRESS,
  BUYER_ADDRESS,
  detectMetamask,
  loadMetamask,
  loadPrivateKey,
  loadWalletRandom,
  loadWallet,
  wei2eth,
  eth2wei,
  userData,
  ethTransfer,
  tokenApprove,
  tokenBurnAll,
  nftData,
  usdtApprove,
  routerBuyUsdt,
  routerBuyToken,
  nftMint,
  nftBurn,
  nftWithdraw,
  nftUpdate,
  nftClaim,
  nftSendRevenue,
  treasuryData,
  coinToToken,
  coinToTokenFromDex,
  tokenToCoin,
  swapCoinToToken,
  swapTokenToCoin,
  treasuryUpdate,
  buyerData,
  buyerBuy,
  buyerUpdate,
  runArbitrage,
  lpvaultData,
  lpvaultUpdate,
  lpvaultApprove,
  lpvaultStake,
  lpvaultUnstake,
  lpvaultClaim,
  lpvaultWithdraw,
  lpvaultTest1,
  bcvSetPricingScale,
  getSignature,
  voteData,
  voteChoice,
  adminData
};


